export const getConsents = (
	locale: string,
	localeRequiresMarketingCommunicationOptIn = false,
	privacyPolicy = '',
) => {
	//TO DO: Get signup to remove this payload reqirement as this is NOT shown to the user
	return {
		site: 'atlassian',
		locale: locale,
		formUrl: window.location.href,
		consents: [
			{
				key: 'termsOfService',
				// showing "" as we do not show anything to the user
				displayedText: '',
				granted: true,
			},
			{
				key: 'privacyPolicy',
				displayedText: privacyPolicy,
				granted: true,
			},
			{
				key: 'generalMarketingOptIn',
				// showing "" as we do not show anything to the user
				displayedText: '',
				granted: !localeRequiresMarketingCommunicationOptIn,
			},
		],
	};
};
